/**
 * MAP TEST 노트 이벤트 상수 — docs/plan/maptest_note.md §5 (2026-10-10 대표 확정).
 * 판정 숫자는 이 파일에서만 정의한다.
 */

/** 이벤트 시작 (UTC ms). null = 제한 없음. */
export const NOTE_EVENT_START_UTC_MS: number | null = null;
/** 이벤트 종료 (UTC ms). null = 무기한. 지나면 보상 지급과 MAP 무료권 사용을 모두 막는다 (롤백 스위치). */
export const NOTE_EVENT_END_UTC_MS: number | null = null;

/** R1 — 인정 좋아요 N개마다 응시권 1장. */
export const NOTE_LIKES_PER_SESSION = 20;
/** R2 — 연속 방문 N일마다 응시권 1장. */
export const NOTE_STREAK_DAYS_PER_SESSION = 10;
/** R2 — 보이는 상태로 머문 최소 시간 (서버 기준 start → confirm 경과). */
export const NOTE_VISIT_MIN_MS = 20_000;
/**
 * R3 — 공식 NWEA MAP 1과목 무료권 자동 지급 스위치. 2026-10-11 대표 결정으로 폐지 → false (새 지급 0).
 * 이미 지급된 무료권·기록 문서는 그대로 두고, 보유자의 신청 (registerFreeWithVoucher) 은 막지 않는다.
 */
export const NOTE_MAPTEST_VOUCHER_ENABLED = false;
/** R3 — 무료권 조건 (둘 중 하나). NOTE_MAPTEST_VOUCHER_ENABLED=false 이면 쓰이지 않는다. */
export const NOTE_VOUCHER_LIKES = 200;
export const NOTE_VOUCHER_SHARES = 100;
/** R4 — 좋아요 인정 하루(KST) 상한. 2026-10-11 부터 공유는 상한에 넣지 않는다 (daily-cap.ts::tryRecognize). */
export const NOTE_DAILY_CAP = 12;
/** R6 — 공유자 본인 기기로 기억하는 최근 기기 수. */
export const NOTE_OWNER_DEVICE_LIMIT = 10;

export interface NoteEventWindow {
  startUtcMs?: number | null;
  endUtcMs?: number | null;
}

/** 이벤트 진행 중인가. window 를 넘기면 상수 대신 그 값을 쓴다 (테스트용). */
export function isNoteEventActive(nowMs: number, window: NoteEventWindow = {}): boolean {
  const start = window.startUtcMs !== undefined ? window.startUtcMs : NOTE_EVENT_START_UTC_MS;
  const end = window.endUtcMs !== undefined ? window.endUtcMs : NOTE_EVENT_END_UTC_MS;
  if (start !== null && nowMs < start) return false;
  if (end !== null && nowMs > end) return false;
  return true;
}

const KST_OFFSET_MS = 9 * 60 * 60 * 1000;

/** UTC ms → KST "YYYYMMDD". */
export function kstDateKey(ms: number): string {
  return new Date(ms + KST_OFFSET_MS).toISOString().slice(0, 10).replace(/-/g, "");
}

/** KST "YYYYMMDD" 의 전날 키. */
export function prevKstDateKey(key: string): string {
  const y = Number(key.slice(0, 4));
  const m = Number(key.slice(4, 6));
  const d = Number(key.slice(6, 8));
  return new Date(Date.UTC(y, m - 1, d - 1)).toISOString().slice(0, 10).replace(/-/g, "");
}


/* ── Navigator 질문하면 관련 글 찾기 (2026-10-16 대표 요청 · ask.ts · posts.ts::askNotePosts) ── */
/** 질문 길이 (자). 2자 미만은 찾지 않는다. */
export const NOTE_ASK_MIN_CHARS = 2;
export const NOTE_ASK_MAX_CHARS = 200;
/** 보여 주는 관련 글 최대 수. */
export const NOTE_ASK_MAX_RESULTS = 5;
/** 질문 조각 가중치 중 글이 덮어야 하는 최소 비율. */
export const NOTE_ASK_MIN_COVERAGE = 0.2;
/** 최소 점수 — 관련 없는 질문 (예: 인사말) 에 엉뚱한 글이 걸리지 않게 (운영 글 111개 시뮬레이션 기준 · tmp-work/_scratch/_ask-sim.ts). */
export const NOTE_ASK_MIN_SCORE = 4;
/** 1등 점수 대비 최소 비율 (이보다 낮은 글은 관련 글로 보이지 않음). */
export const NOTE_ASK_REL_CUTOFF = 0.3;
/** 질문 기록 (note_questions) KST 하루 상한 — 넘으면 찾기는 되고 기록만 안 한다. */
export const NOTE_ASK_LOG_DAILY_MAX = 1000;
